
export default class PrimaryFiltersViewModel {
    headerIndex: number = 0;
    minHeader: number | null = null;
    maxHeader: number | null = null;
    actualMinHeader: number | null = null;
    actualMaxHeader: number | null = null;
    minParkingSpaces: number | null = null;
    maxParkingSpaces: number | null = null;
    parkingSpacesChecked: boolean | null = true;
    minParkingSpacesPerDwelling: number | null = null;
    maxParkingSpacesPerDwelling: number | null = null;
    parkingSpacesPerDwellingChecked: boolean | null = true;
    minBedroomPerDwelling: number | null = null;
    maxBedroomPerDwelling: number | null = null;
    bedroomPerDwellingChecked: boolean | null = true;
    percentDwellingsOption: 'min' | 'max' = 'min';
    minPercentDwellings: number | null = null;
    maxPercentDwellings: number | null = null;
    percentDwellingsChecked: boolean | null = true;
    startDate: Date | null = null;
    endDate: Date | null = null;

    daysOfWeek: number[] = [1, 2, 3, 4, 5, 6, 7];
    locationTypes: number[] = [0, 1, 2, 3, 4, 5, 6];
    subLocationTypes: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    surveyTypes: number[] = [1, 2]
    serviceVehicles: (string | null)[] = ["Y", null]
    publicTransportProvision: number = 0;
    publicTransportMin: number = 0;
    publicTransportMax: number = 0;
    includeNullRowsForPublicTransport: boolean = true;
}